// import React, { useState, useEffect } from 'react';
// import { useAppSelector } from '../../../hooks';
// import { selectAuth } from '../../../features/authSlice';
// import { KTSVG } from '../../../_metronic/helpers';
// import { PageTitle } from '../../../_metronic/layout/core';
// import Pagination from '../../../components/pagination/Pagination';
// import SearchBarComponent from '../../../components/searchBar/SearchBarComponent';
// import NoRecordFound from '../../../components/noRecord/NoRecordFound';
// import { LoadingComponent } from '../../../components/loadingComponent/LoadingComponent';
// import { constraintConfig } from '../../../constraintConfig';
// import { Tooltip } from 'react-tooltip';
// import labelKey from "../../localization/label.json"
// import ImpersonateUserModal from '../users/ImpersonateUserModal';


// const ImpersonateUser: React.FC = () => {
//   const { userAccountID, roleID } = useAppSelector(selectAuth);
  
//   // State variables - you can modify these based on your API
//   const [page, setPage] = useState(1);
//   const [pageSize, setPageSize] = useState(10);
//   const [searchStr, setSearchStr] = useState('');
//   const [immediateSearchStr, setImmediateSearchStr] = useState('');
//   const [sortBy, setSortBy] = useState("createDT");
//   const [sortOrder, setSortOrder] = useState("desc");
//   const [sortedColumn, setSortedColumn] = useState("createDT");
//    const [impersonateUserModal, setImpersonateUserModal] = useState(false);
//     const [impersonateData, setImpersonateData] = useState({});
//     const impersonateHandler = () => {
//         setImpersonateUserModal((prev) => !prev);
//     };

//   // Mock data - replace with your actual API data
//   const [usersData, setUsersData] = useState<any>({
//     result: {
//       data: [],
//       totalRecords: 0,
//       pageNumber: 1,
//       pageSize: 10,
//       totalPages: 0
//     }
//   });
//   const [isLoading, setIsLoading] = useState(false);

//   // Pagination handlers
//   const handlePageClick = (e: any) => {
//     setPage(e.selected + 1);
//   };

//   const handlePageSizeChange = (e: any) => {
//     const newSize = parseInt(e.target.value);
//     setPageSize(newSize);
//     setPage(1);
//   };

//   // Sorting handlers
//   const handleSort = (property: string) => {
//     setSortBy(property);
//     if (sortedColumn === property) {
//       setSortOrder(prevSortOrder => (prevSortOrder === "asc" ? "desc" : "asc"));
//     } else {
//       setSortedColumn(property);
//       setSortOrder("asc");
//     }
//   };

//   // Search handlers
//   const handleSearchChange = (e: any) => {
//     const { value } = e.target;
//     setImmediateSearchStr(value);
//     setSearchStr(value);
//     setPage(1);
//   };

//   // Impersonation handlers
//   const handleImpersonate = async (user: any) => {
//     if (!user) return;
    
//     try {
//       // Here you would implement the actual impersonation logic
//       console.log('Impersonating user:', user);
      
//       // You might want to redirect to a different page or update the UI
//       // window.location.href = `/dashboard?impersonate=${user.userAccountID}`;
      
//     } catch (error) {
//       console.error('Error impersonating user:', error);
//     }
//   };

//   // Mock function to fetch data - replace with your actual API call
//   const fetchUsers = async () => {
//     setIsLoading(true);
//     // Simulate API call
//     setTimeout(() => {
//       // Replace this with your actual API call
//       setUsersData({
//         result: {
//           data: [
//             {
//               userAccountID: 1,
//               firstName: 'John',
//               lastName: 'Doe',
//               email: 'john.doe@example.com',
//               department: { title: 'Engineering' },
//               designation: { title: 'Developer' },
//               cellPhone: '+1234567890',
//               createDT: '2024-01-01T00:00:00Z'
//             }
           
//           ],
//           totalRecords: 1,
//           pageNumber: page,
//           pageSize: pageSize,
//           totalPages: 1
//         }
//       });
//       setIsLoading(false);
//     }, 1000);
//   };

//   useEffect(() => {
//     fetchUsers();
//   }, [page, pageSize, searchStr, sortBy, sortOrder]);

//   return (
//     <>
//                 <ImpersonateUserModal show={impersonateUserModal} handleClose={() => setImpersonateUserModal(false)} data={impersonateData} />
    
//       <PageTitle breadcrumbs={[]}>Impersonate User</PageTitle>
      
//       <div className='card mb-5'>
//         <div className='card-header border-0'>
//           <div className='card-title'>
//             <SearchBarComponent
//               placeholder='Search Users'
//               value={immediateSearchStr}
//               onChange={handleSearchChange}
//             />
//           </div>
//         </div>
        
//         <div className='card-body py-3'>
//           <div className="col-md-12">
//             <div className='table-responsive table-height'>
//               <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
//                 <thead>
//                   <tr className='fw-bold text-muted'>
//                     <th className='min-w-40px rounded-start text-center'>Sr</th>
//                     <th className='min-w-120px' onClick={() => handleSort("firstName")}>
//                       <div className='table-arrow'>
//                         Name
//                         {sortedColumn === "firstName" ? (
//                           <>
//                             {sortOrder === "desc" ? '↓' : '↑'}
//                           </>
//                         ) : ''}
//                       </div>
//                     </th>
//                     <th className='min-w-120px' onClick={() => handleSort("department")}>
//                       <div className='table-arrow'>
//                         Department
//                         {sortedColumn === "department" ? (
//                           <>
//                             {sortOrder === "desc" ? '↓' : '↑'}
//                           </>
//                         ) : ''}
//                       </div>
//                     </th>
//                     <th className='min-w-120px' onClick={() => handleSort("designation")}>
//                       <div className='table-arrow'>
//                         Designation
//                         {sortedColumn === "designation" ? (
//                           <>
//                             {sortOrder === "desc" ? '↓' : '↑'}
//                           </>
//                         ) : ''}
//                       </div>
//                     </th>
//                     <th className='min-w-140px' onClick={() => handleSort("cellPhone")}>
//                       <div className='table-arrow'>
//                         Phone
//                         {sortedColumn === "cellPhone" ? (
//                           <>
//                             {sortOrder === "desc" ? '↓' : '↑'}
//                           </>
//                         ) : ''}
//                       </div>
//                     </th>
//                     <th className='min-w-140px' onClick={() => handleSort("createDT")}>
//                       <div className='table-arrow'>
//                         Created Date
//                         {sortedColumn === "createDT" ? (
//                           <>
//                             {sortOrder === "desc" ? '↓' : '↑'}
//                           </>
//                         ) : ''}
//                       </div>
//                     </th>
//                     <th className='min-w-100px rounded-end pe-4 '>Actions</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {!isLoading && (
//                     <>
//                       {usersData?.result?.data?.length > 0 ? (
//                         <>
//                           {usersData?.result?.data?.map((data: any, index: any) => (
//                             <tr key={index}>
//                               <td className='text-center'>
//                                 {(page - 1) * pageSize + index + 1}
//                               </td>
//                               <td>
//                                 <div className="d-flex align-items-center">
//                                   <div className="symbol symbol-circle symbol-50px overflow-hidden me-3">
//                                     <div className="symbol-label fs-3 bg-light-info text-info text-capitalize">
//                                       {data?.firstName?.charAt(0)}
//                                     </div>
//                                   </div>
//                                   <div className="d-flex flex-column">
//                                     <span className="text-gray-800 fw-semibold mb-1 text-capitalize">
//                                       {data?.firstName} {data?.lastName}
//                                     </span>
//                                     <span className='text-lowercase'>{data?.email}</span>
//                                   </div>
//                                 </div>
//                               </td>
//                               <td>{data?.department?.title ? data?.department?.title : "N/A"}</td>
//                               <td>{data?.designation?.title ? data?.designation?.title : "N/A"}</td>
//                               <td>{data?.cellPhone ? data?.cellPhone : "N/A"}</td>
//                               <td>{data?.createDT ? new Date(data.createDT).toLocaleDateString() : "N/A"}</td>
//                               <td>
//                                   {/* {(roleID === constraintConfig.roleID.role2 || roleID === constraintConfig.roleID.roleExecutive) && data?.active === true && */}
//                                                                                                            <>
//                                                                                                                <Tooltip id="impersonate" place="top" />
//                                                                                                                <span className="badge badge-light-primary fw-semibold"
//                                                                                                                    onClick={() => {
//                                                                                                                        setImpersonateData(data);
//                                                                                                                        impersonateHandler();
//                                                                                                                    }}
//                                                                                                                >{labelKey.impersonateUser}</span>
//                                                                                                            </>
//                                                                                                            {/* } */}
//                               </td>
//                             </tr>
//                           ))}
//                         </>
//                       ) : (
//                         <tr>
//                           <td colSpan={7}>
//                             <NoRecordFound />
//                           </td>
//                         </tr>
//                       )}
//                     </>
//                   )}
                  
//                   {isLoading && (
//                     <tr>
//                       <td colSpan={7} className="text-center">
//                         <LoadingComponent />
//                       </td>
//                     </tr>
//                   )}
//                 </tbody>
//               </table>
//             </div>
            
//             <Pagination
//               totalResult={usersData?.result?.totalRecords === 0 ? 0 : ((usersData?.result?.pageNumber - 1) * usersData?.result?.pageSize) + 1}
//               toResult={usersData?.result?.totalRecords === 0 ? 0 : Math.min(usersData?.result?.pageNumber * usersData?.result?.pageSize, usersData?.result?.totalRecords)}
//               ofResult={usersData?.result?.totalRecords}
//               onChange={handlePageSizeChange}
//               pageSize={pageSize}
//               onPageChange={handlePageClick}
//               pageCount={usersData?.result?.totalPages || 0}
//               currentPage={page}
//             />
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export { ImpersonateUser };

import React, { useState } from 'react';
import { useAppSelector } from '../../../hooks';
import { selectAuth } from '../../../features/authSlice';
import { PageTitle } from '../../../_metronic/layout/core';
import Pagination from '../../../components/pagination/Pagination';
import SearchBarComponent from '../../../components/searchBar/SearchBarComponent';
import NoRecordFound from '../../../components/noRecord/NoRecordFound';
import { LoadingComponent } from '../../../components/loadingComponent/LoadingComponent';
import { Tooltip } from 'react-tooltip';
import labelKey from "../../localization/label.json"
import ImpersonateUserModal from '../users/ImpersonateUserModal';
import { constraintConfig } from '../../../constraintConfig';
import { useGetUserImpersonateTableDataQuery } from '../../../services/authApi';

const ImpersonateUser: React.FC = () => {
  const { roleID, userAccountID } = useAppSelector(selectAuth);

  // pagination + sorting + search states
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [searchStr, setSearchStr] = useState('');
  const [immediateSearchStr, setImmediateSearchStr] = useState('');
  const [sortBy, setSortBy] = useState("createDT");
  const [sortOrder, setSortOrder] = useState("desc");
  const [sortedColumn, setSortedColumn] = useState("createDT");

  // impersonate modal states
  const [impersonateUserModal, setImpersonateUserModal] = useState(false);
  const [impersonateData, setImpersonateData] = useState<any>({});

  const impersonateHandler = () => setImpersonateUserModal(prev => !prev);

  // ✅ API call using RTK Query
  const { data: usersData, isLoading, isError } = useGetUserImpersonateTableDataQuery({
    pageNumber: page,
    pageSize: pageSize,
    sortBy,
    sortOrder,
    searchStr,
    managerId: userAccountID, // 👈 from auth
    filterByDepartment: "",
    filterByDesignation: "",
    filterByStatus: ""
  });

  // handlers
  const handlePageClick = (e: any) => setPage(e.selected + 1);

  const handlePageSizeChange = (e: any) => {
    setPageSize(parseInt(e.target.value));
    setPage(1);
  };

  const handleSort = (property: string) => {
    setSortBy(property);
    if (sortedColumn === property) {
      setSortOrder(prev => (prev === "asc" ? "desc" : "asc"));
    } else {
      setSortedColumn(property);
      setSortOrder("asc");
    }
  };

  const handleSearchChange = (e: any) => {
    const { value } = e.target;
    setImmediateSearchStr(value);
    setSearchStr(value);
    setPage(1);
  };

  return (
    <>
      <ImpersonateUserModal
        show={impersonateUserModal}
        handleClose={() => setImpersonateUserModal(false)}
        data={impersonateData}
      />

      <PageTitle breadcrumbs={[]}>Impersonate User</PageTitle>

      <div className='card mb-5'>
        <div className='card-header border-0'>
          <div className='card-title'>
            <SearchBarComponent
              placeholder='Search Users'
              value={immediateSearchStr}
              onChange={handleSearchChange}
            />
          </div>
        </div>

        <div className='card-body py-3'>
          <div className="col-md-12">
            <div className='table-responsive table-height'>
              <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                <thead>
                  <tr className='fw-bold text-muted'>
                    <th className='min-w-40px rounded-start text-center'>Sr</th>
                    <th className='min-w-120px' onClick={() => handleSort("firstName")}>
                      <div className='table-arrow'>
                        Name {sortedColumn === "firstName" ? (sortOrder === "desc" ? "↓" : "↑") : ""}
                      </div>
                    </th>
                    <th className='min-w-120px' onClick={() => handleSort("department")}>
                      <div className='table-arrow'>
                        Department {sortedColumn === "department" ? (sortOrder === "desc" ? "↓" : "↑") : ""}
                      </div>
                    </th>
                    <th className='min-w-120px' onClick={() => handleSort("designation")}>
                      <div className='table-arrow'>
                        Designation {sortedColumn === "designation" ? (sortOrder === "desc" ? "↓" : "↑") : ""}
                      </div>
                    </th>
                    <th className='min-w-140px' onClick={() => handleSort("cellPhone")}>
                      <div className='table-arrow'>
                        Phone {sortedColumn === "cellPhone" ? (sortOrder === "desc" ? "↓" : "↑") : ""}
                      </div>
                    </th>
                    <th className='min-w-140px' onClick={() => handleSort("createDT")}>
                      <div className='table-arrow'>
                        Created Date {sortedColumn === "createDT" ? (sortOrder === "desc" ? "↓" : "↑") : ""}
                      </div>
                    </th>
                    <th className='min-w-100px rounded-end pe-4'>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {!isLoading && usersData?.result?.data?.length > 0 && (
                    usersData.result.data.map((data: any, index: number) => (
                      <tr key={data.userAccountID}>
                        <td className='text-center'>
                          {(page - 1) * pageSize + index + 1}
                        </td>
                        <td>
                          <div className="d-flex align-items-center">
                            <div className="symbol symbol-circle symbol-50px overflow-hidden me-3">
                              <div className="symbol-label fs-3 bg-light-info text-info text-capitalize">
                                {data?.firstName?.charAt(0)}
                              </div>
                            </div>
                            <div className="d-flex flex-column">
                              <span className="text-gray-800 fw-semibold mb-1 text-capitalize">
                                {data?.firstName} {data?.lastName}
                              </span>
                              <span className='text-lowercase'>{data?.email}</span>
                            </div>
                          </div>
                        </td>
                        <td>{data?.department?.title || "N/A"}</td>
                        <td>{data?.designation?.title || "N/A"}</td>
                        <td>{data?.cellPhone || "N/A"}</td>
                        <td>{data?.createDT ? new Date(data.createDT).toLocaleDateString() : "N/A"}</td>
                        <td>
                         {data?.active === true && (
                          <>
                          <Tooltip id="impersonate" place="top" />
                          <span
                            className="badge badge-light-primary fw-semibold"
                            onClick={() => {
                              setImpersonateData(data);
                              impersonateHandler();
                            }}
                          >
                            {labelKey.impersonateUser}
                          </span>
                          </>
                         )}
                          
                        </td>
                      </tr>
                    ))
                  )}

                  {!isLoading && (!usersData?.result?.data || usersData.result.data.length === 0) && (
                    <tr>
                      <td colSpan={7}>
                        <NoRecordFound />
                      </td>
                    </tr>
                  )}

                  {isLoading && (
                    <tr>
                      <td colSpan={7} className="text-center">
                        <LoadingComponent />
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            <Pagination
              totalResult={usersData?.result?.totalRecords === 0 ? 0 : ((usersData?.result?.pageNumber - 1) * usersData?.result?.pageSize) + 1}
              toResult={usersData?.result?.totalRecords === 0 ? 0 : Math.min(usersData?.result?.pageNumber * usersData?.result?.pageSize, usersData?.result?.totalRecords)}
              ofResult={usersData?.result?.totalRecords}
              onChange={handlePageSizeChange}
              pageSize={pageSize}
              onPageChange={handlePageClick}
              pageCount={usersData?.result?.totalPages || 0}
              currentPage={page}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export { ImpersonateUser };
